import type { MediaItem } from "@/domain/Breeds/breeds.types";

export const adapterGallery = (gallery: MediaItem[]) => {
  return gallery.map((image) => {
    return {
      name: image?.attributes?.name,
      url: image?.attributes?.url
    };
  });
};
